/**
 * Vite serves the SPA from a dev port while Django runs on the same hostname, usually :8000.
 * A browser navigation on the Vite dev server loads this SPA. Full-page jumps after
 * session auth must target the backend origin when it differs from the dev port.
 */
function djangoOriginInDev(): string {
  if (!import.meta.env.DEV) return "";
  const explicit = (import.meta.env.VITE_BACKEND_ORIGIN as string | undefined)?.trim();
  if (explicit) return explicit.replace(/\/$/, "");
  if (typeof window === "undefined") return "";
  const { protocol, hostname, port } = window.location;
  // Same host as the SPA; Django dev server is conventionally on 8000 (see vite.config proxy).
  if (!port || port === "80" || port === "443") return "";
  return `${protocol}//${hostname}:8000`;
}

/** POST-login redirect target (Django sets session then sends user to the dashboard). */
export function postLoginHref(): string {
  const base = djangoOriginInDev();
  return base ? `${base}/accounts/post-login/` : "/accounts/post-login/";
}

/** Full navigation to the main Django app home (dashboard HTML at `/`). */
export function dashboardHref(): string {
  const base = djangoOriginInDev();
  return base ? `${base}/` : "/";
}
